function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { StyledFooter } from '../elements/styledFooter';
const Footer = ({
  children,
  hasDivider = false,
  ...other
}) => /*#__PURE__*/React.createElement(StyledFooter, _extends({
  hasDivider: hasDivider
}, other), children);
export { Footer };